import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui-Standard: classnames-Merger mit Tailwind-Konflikt-Auflösung.
 * `cn('px-2 py-1', condition && 'px-4')` → letzteres gewinnt.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Format ISO-Timestamp als deutsches "vor 12 Min." / "heute 08:42" / Datum.
 * Wird für DataState.last_successful_fetch_at überall genutzt.
 */
export function formatRelativeTime(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return '–';
  const then = new Date(iso);
  const diffSec = Math.floor((now.getTime() - then.getTime()) / 1000);

  if (diffSec < 30) return 'gerade eben';
  if (diffSec < 60) return `vor ${diffSec} Sek.`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `vor ${diffMin} Min.`;

  const isSameDay =
    then.getFullYear() === now.getFullYear() &&
    then.getMonth() === now.getMonth() &&
    then.getDate() === now.getDate();
  const time = then.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  if (isSameDay) return `heute ${time}`;

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    then.getFullYear() === yesterday.getFullYear() &&
    then.getMonth() === yesterday.getMonth() &&
    then.getDate() === yesterday.getDate();
  if (isYesterday) return `gestern ${time}`;

  return then.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' }) + ` ${time}`;
}

/**
 * Format "Letzter erfolgreicher Abruf:" für DataState-Stale-Hinweis.
 */
export function formatLastFetch(iso: string | null | undefined): string {
  if (!iso) return 'Noch nicht abgerufen';
  return `Letzter erfolgreicher Abruf: ${formatRelativeTime(iso)}`;
}
